import React from 'react';
const PipeShortVerticalIcon = ({ width = 64, height = 64 }) => {
  const id = React.useId().replace(/:/g, '');
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 29.7 112.5">
      <defs>
        <linearGradient id={`${id}_1`} gradientUnits="userSpaceOnUse" x1="0" y1="56.25" x2="29.6997" y2="56.25">
          <stop offset="0.01" stopColor="#646464" />
          <stop offset="0.18" stopColor="#949494" />
          <stop offset="0.5" stopColor="#DFDFDF" />
          <stop offset="1" stopColor="#656565" />
        </linearGradient>
      </defs>
      <path fill={`url(#${id}_1)`} d="M0,112.5V0h29.7v112.5H0z" />
    </svg>
  );
};
export default PipeShortVerticalIcon;
